export enum TokenType {
    AuthenticationToken = 1,
    TouchID = 2,
    RememberMe = 3,
    NemIdToken = 4,
    MFAToken = 5,
    PendingActionToken = 6,
    BankIdToken = 7,
    MigrationToken = 8
}